<template>
<div class="o-level main-header-nav">
  <div class="o-level__left">
    <span v-if="$isMobile()" class="o-level__item">
      <a
        href=""
        class="toggle-side-menu-btn"
        @click.prevent="$emit('toggleSideMenu')"
      >
        <font-awesome-icon icon="bars" />
      </a>
    </span>
    <span class="o-level__item">Front End Vue</span>
  </div>
  <div class="o-level__right">
    <span class="o-level__item">
      <a
        href=""
        class="u-p-small"
        @click.prevent="$router.push({ name: 'login'})"
        v-tooltip.top-center="'Salir'"
      >
        <font-awesome-icon icon="sign-out-alt" />
      </a>
    </span>
  </div>
</div>
</template>

<script>
export default {
  name: 'mainHeaderNav'
}
</script>
